class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  handleSticky() {
    const topbarHeight = 71;
    const headerHeight = 47;

    const announcementBarEl = document.querySelector('.m-announcement-bar');
    const topbarEl = document.querySelector('.m-topbar');
    let announcementHeight = announcementBarEl ? announcementBarEl.offsetHeight : 0;
    let lastScroll = 0;
    let isDesktop = window.innerWidth >= 1024;
    let rafPending = false;

    const onScroll = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        const currentScroll = window.scrollY;

        if (isDesktop) {
          if (currentScroll <= announcementHeight) {
            this.classList.remove(this.classes.scrollUp, this.classes.scrollDown, this.classes.stuck, this.classes.always);
            document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
            if (topbarEl) topbarEl.style.transform = 'translateY(0)';
            if (announcementBarEl) announcementBarEl.style.transform = 'translateY(0)';
            lastScroll = currentScroll;
            return;
          }

          this.classList.add(this.classes.stuck);
          if (topbarEl) topbarEl.style.transform = 'translateY(0)';
          if (announcementBarEl) announcementBarEl.style.transform = 'translateY(-100%)';
        } else {
          if (currentScroll <= announcementHeight) {
            this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
            document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
            if (announcementBarEl) announcementBarEl.style.transform = 'translateY(0)';
            lastScroll = currentScroll;
            return;
          }

          this.classList.add(this.classes.stuck);
          if (announcementBarEl) announcementBarEl.style.transform = 'translateY(-100%)';
        }

        lastScroll = currentScroll;
      });
    };

    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        isDesktop = window.innerWidth >= 1024;
        if (announcementBarEl) {
          announcementHeight = announcementBarEl.offsetHeight;
        }
      }, 150);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
  }
}

customElements.define("m-header", MHeader);
